import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'

import { ServerResponseSchema } from 'app'
import System from 'system'
import { ProgressBar } from 'ui'

import { creatorFetch, creatorFetchCanceled, creatorSaveFetch } from '../../actions'
import CreateForm from '../../components/CreateForm'
import { getStateCreator } from '../../reducer'

import styles from './index.css'

const asOptions = (list = []) =>
  list.map((c) => ({
    ...c,
    key: c.id,
    text: c.name,
    value: c.id,
  }))

class CreatorScreen extends PureComponent {
  componentDidMount() {
    this.props.creatorFetch()
  }

  componentWillUnmount() {
    this.props.creatorFetchCanceled()
  }

  componentDidUpdate(prevProps) {
    if (
      !prevProps.creator.serverResponse.loaded &&
      this.props.creator.serverResponse.loaded &&
      !this.props.creator.serverResponse.error &&
      this.props.creator.serverResponse?.data?.[0]?.id
    ) {
      System.history.push(`/st/${this.props.creator.serverResponse.data[0].id}`)
    }
  }

  render() {
    const { creator } = this.props
    return (
      <div className={styles.container}>
        {!creator.loaded || creator.loading ? (
          <ProgressBar value={100} />
        ) : (
          <CreateForm
            categories={asOptions(creator.data[0].categories)}
            cities={asOptions(creator.data[0].cities)}
            disciplines={asOptions(creator.data[0].disciplines)}
            genders={asOptions(creator.data[0].genders)}
            institutions={asOptions(creator.data[0].institutions)}
            institutionTypes={asOptions(creator.data[0].institutionTypes)}
            levels={asOptions(creator.data[0].levels)}
            onCancel={() => window.history.back()}
            onSave={this.props.creatorSaveFetch}
            saving={!!this.props.creator.serverResponse.loading}
          />
        )}
      </div>
    )
  }
}

CreatorScreen.propTypes = {
  creator: ServerResponseSchema.isRequired,
  creatorFetch: PropTypes.func.isRequired,
  creatorFetchCanceled: PropTypes.func.isRequired,
  creatorSaveFetch: PropTypes.func.isRequired,
}

export class Pure extends CreatorScreen {}

Pure.displayName = 'CreatorScreen'

export default connect((state) => ({ creator: getStateCreator(state) }), {
  creatorFetch,
  creatorFetchCanceled,
  creatorSaveFetch,
})(CreatorScreen)
